import { useStage } from './useStage'

export default () => useStage('government-id-selfie')
